// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Aerodrome } from './Aerodrome';
import { Coordinate } from './Coordinate';
import { FlightPlan } from './FlightPlan';
import { PathPoint } from './PathPoint';
import { Flight } from './Flight';

export enum PathPointLoadClassification {
    OVERLOAD = "OVERLOAD",
    HIGH = "HIGH",
    LOW = "LOW",
}